import { FETCH_COMMODITIES } from 'actions';

export default (state = [], action) => {
	switch (action.type) {
		case FETCH_COMMODITIES:
			return action.payload;
		default:
			return state;
	}
};